import React from 'react';
import TabsComponent from '../../../../components/Tabs/Tabs';
import DataInjestForm from './DataInjestForm';
import classes from './index.module.css';
import MongooseSchema from './MongooseSchema';

const DataInjest = () => {
    const tabs = [
        {
            name: 'Data injest',
            component: <DataInjestForm />,
            tabId: 1,
        },
        {
            name: 'Mongoose Schema',
            component: <MongooseSchema />,
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent selectedIndex={0} tabs={tabs} />
        </div>
    );
};

export default DataInjest;
